<template>
  <Modal v-model="show" width="860" :transfer="true" class="modal-box">
    <p slot="header">
      批量设置<span
        v-if="tableSelection.length"
        style="padding-left: 10px; color: #999999"
      >(已选请假单{{ tableSelection.length }})</span>
    </p>
    <div class="iconTips">
      <Icon
        type="md-alert"
        size="16"
        color="#ff9900"
        style="padding-right: 10px"
      ></Icon>每次只能批量修改一项
    </div>
    <div class="modal-content">
      <div class="modal-left">
        <div class="menu-box">
          <Menu mode="vertical" :active-name="menuName" @on-select="handleMenu">
            <MenuItem
              v-for="(item, index) in menuList"
              :key="index"
              :name="item.menuName"
            >
              {{ item.name }}
            </MenuItem>
          </Menu>
        </div>
      </div>
      <div class="modal-right">
        <div v-if="menuName == 1" class="item1">
          <div class="flex">
            批量设置：
            <RadioGroup v-model="batchData.check">
              <Radio label="1">批量通过</Radio>
              <Radio label="2">批量驳回</Radio>
            </RadioGroup>
          </div>
          <div style="padding-left: 85px; padding-top: 4px">
            <Input
              v-model="batchData.textarea"
              style="padding-bottom: 6px"
              type="textarea"
              placeholder="请输入审批说明"
            ></Input>
            <span>仅支持批量设置待审批状态的请假单！！</span>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <div slot="footer">
      <Button @click="handleCancle">取消</Button>
      <Button type="primary" @click="handleSubmit('formValidate')">确定</Button>
    </div>
  </Modal>
</template>
<script>
import { mapGetters } from 'vuex';
import eduCenter from '@/request/eduCenter/index.js';
import { formatTimeHour, formatTime } from '@/utils/utils';

export default {
  props: {
    tableSelection: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      show: false,
      menuName: '1',
      batchData: {
        check: '1',
        refund: '1',
        textarea: ''
      }

    };
  },
  computed: {
    ...mapGetters(['theUserIdentity']),
    menuList() {
      return [
        {
          menuName: '1',
          name: '批量请假单审批'
        }
      ];
    }
  },
  watch: {
    tableSelection: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {

      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.menuName = this.menuList[0].menuName;
      for (const k in this.batchData) {
        this.batchData[k] = '1';
        if (k == 'textarea') {
          this.batchData[k] = '';
        }
      }
    },
    handleShow() {
      this.init();
      this.show = true;
    },
    // 切换菜单
    handleMenu(name) {
      this.menuName = name;
    },
    // 批量设置点击取消
    handleCancel() {
      Object.keys(this.batchData).forEach((item) => {
        this.batchData[item] = '';
      });
      this.batchData.addfixName = true;
    },
    // 批量设置点击确定
    handleOk() {
      let params;
      const { check, refund, textarea } = this.batchData;
      const leaveIds = this.tableSelection.map(item => { return item.leaveId; });
      switch (this.menuName) {
        case '1':
          params = {
            leaveIds: leaveIds,
            leaveState: Number(check),
            reviewReason: textarea
          };
          this.batchUpdate(params);
          break;
      }
    },
    handleCancle() {
      this.show = false;
    },
    handleSubmit() {
      if (this.menuName == 1) {
        // menuName
        const key = this.tableSelection.findIndex(item => { return item.leaveState != 0; });
        if (key > -1) {
          this.$Message.warning('仅支持批量设置待审批状态的请假单！请确认后重新操作。');
          return null;
        }
        if (this.batchData.check == 2 && !this.batchData.textarea) {
          this.$Message.warning('请输入审批说明');
          return null;
        }
      }
      this.handleOk();
    },
    async batchUpdate(params) {
      let res;
      this.$Spin.show();
      switch (this.menuName) {
        case '1':
          res = await eduCenter.postAatchTeacherLeaveAuditApi(params);
          break;
      }
      this.$Spin.hide();
      if (res.status == 200) {
        this.show = false;
        this.$Message.success('设置成功');
        this.$emit('on-finish',);
      }
    }

  }
};
</script>
<style lang="scss" scoped>
.modal-box {
  .iconTips {
    display: flex;
    align-items: center;
    padding-left: 20px;
    margin: 0 0 10px 10px;
    width: 600px;
    height: 30px;
    background-color: #fadfb8;
    border: solid 1px #ff9900;
  }
  .modal-content {
    display: flex;
    justify-content: space-around;
    .modal-left {
      float: left;
    }
    .modal-right {
      float: right;
      width: 500px;
      span {
        color: red;
        font-size: 10px;
      }
      .item1 {
        div {
          margin: 0 0 2px 0;
        }
      }
    }
  }
}
</style>
